// angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// service imports
import { HelperService } from '../../../_services/shared-services/helper.service';
import { PrecisionService } from '../../../_services/shared-services/precision.service';

// model imports
import { WorkflowInfo } from '../../_models/workflow-info';
import { WFInvoiceHistoryParametersDto } from '../../_models/wf-invoice-history-parameters-dto';

@Component({
    selector: 'app-workflow-invoice-reclassify-header-details',
    templateUrl: './workflow-invoice-reclassify-header-details.component.html',
    styleUrls: ['./workflow-invoice-reclassify-header-details.component.scss']
})
export class WorkflowInvoiceReclassifyHeaderDetailsComponent {
    @Input() workflowInfo: WorkflowInfo;
    @Input() communityId: number;
    @Output() onUpdateDescription = new EventEmitter<string>();

    invoiceHistoryBaseParams: WFInvoiceHistoryParametersDto;
    showInvoiceHistory = false;

    iconCross = IconConstants.CROSS;
    iconCheck = IconConstants.CHECK;
    iconEdit = IconConstants.EDIT;

    constructor(private readonly helperService: HelperService, private readonly precisionService: PrecisionService) {}

    onInvoiceClick(): void {
        this.invoiceHistoryBaseParams = new WFInvoiceHistoryParametersDto();
        this.invoiceHistoryBaseParams.communityId = this.communityId;
        this.invoiceHistoryBaseParams.invoiceNumber = this.workflowInfo.invoiceNumber;
        this.invoiceHistoryBaseParams.payeeCode = this.workflowInfo.payeeCode;

        this.showInvoiceHistory = true;
    }

    getFormattedDate(dt: Date): string {
        return !!dt ? this.helperService.getDateString(dt) : null;
    }

    getFormattedCurrency(value: number): number {
        return this.precisionService.getRoundedNumber(value);
    }

    onCloseHistory(): void {
        this.showInvoiceHistory = false;
    }

    onUpdateDescriptionClick(): void {
        this.onUpdateDescription.emit(this.workflowInfo.description);
    }
}
